import { render } from "./TheValue.vue?vue&type=template&id=331e4f06&scoped=true&lang=html"
import script from "./TheValue.vue?vue&type=script&lang=js"
export * from "./TheValue.vue?vue&type=script&lang=js"

import "./TheValue.vue?vue&type=style&index=0&id=331e4f06&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331e4f06"]])

export default __exports__